export default __webpack_public_path__ + "static/media/arrow-forward.9146cef8.svg";